import { Tooltip } from "@mui/material";
import { useState } from "react";

export default function Copiable({ children, text }) {
  const [tooltipText, setTooltipText] = useState("Click to copy");
  const onCopy = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.navigator.clipboard.writeText(text);
    setTooltipText("Copied!");
    setTimeout(() => {
      setTooltipText("Click to copy");
    }, 3000);
  };
  return (
    <Tooltip title={tooltipText} placement="top">
      <div onClick={onCopy}>{children}</div>
    </Tooltip>
  );
}
